export { default } from './NoFeaturedPopularFaresAlert';
